/* PhotoHouse V8.1 — CART VISIBILITY FIX.
 * Kingdom's AJAX add-to-cart already works. The alternate desktop header
 * hides .sidebar using display:none, which also hides its genuine cart drawer.
 * Portal the very SAME drawer outside that hidden sidebar on desktop only.
 * Keep Kingdom's bound events, cart form, discount logic and mobile untouched.
 */
(function(){
  'use strict';
  var desktop=window.matchMedia('(min-width:949px)');
  function sectionHolder(){
    var section=document.getElementById('shopify-section-sidebar');
    return section&&section.querySelector('.sidebar__container-holder');
  }
  function portaled(){return document.querySelector('body > .sidebar__cart.ph-v8-cart-portal');}
  function inSidebar(holder){
    return holder&&holder.querySelector(':scope > .sidebar__cart');
  }
  function returnToSidebar(cart,holder){
    if(!cart||!holder)return;
    // A change of breakpoint closes the open drawer before restoring mobile UX.
    cart.classList.remove('opened','ph-v8-cart-portal');
    cart.style.removeProperty('transform');
    var search=holder.querySelector(':scope > .sidebar__search');
    holder.insertBefore(cart,search||null);
    var overlay=document.querySelector('.cart-overlay-background');
    if(overlay)overlay.classList.remove('show');
    document.body.classList.remove('overflow-hidden');
  }
  function reconcile(){
    if(!document.body||!document.body.classList.contains('ph-v3-header'))return;
    var holder=sectionHolder();
    var nested=inSidebar(holder);
    var existing=portaled();
    // Shopify Theme Editor can re-render the sidebar section independently.
    if(nested&&existing&&nested!==existing){existing.remove();existing=null;}
    if(desktop.matches){
      if(nested){nested.classList.add('ph-v8-cart-portal');document.body.appendChild(nested);}
    }else if(existing){
      returnToSidebar(existing,holder);
    }
  }
  function openFromTopbar(event){
    if(!desktop.matches||!document.body.classList.contains('ph-v3-header'))return;
    if(window.cart_action!=='overlay'||document.body.classList.contains('template-cart'))return;
    if(!portaled())reconcile();
    if(!portaled())return; // The native /cart link remains a safe fallback.
    var kingdomHandle=document.querySelector('#shopify-section-sidebar .sidebar__cart-handle');
    if(!kingdomHandle)return;
    event.preventDefault();
    // Trigger KING.Sidebar's existing click callback, not another cart UI.
    if(window.jQuery)window.jQuery(kingdomHandle).trigger('click');
    else kingdomHandle.click();
  }
  function bindTopbar(){
    var link=document.querySelector('.ph-v3__topbar-cart');
    if(!link||link.dataset.phV81Bound==='1')return;
    link.dataset.phV81Bound='1';
    link.addEventListener('click',openFromTopbar);
  }
  function mount(){reconcile();bindTopbar();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);
  else mount();
  if(desktop.addEventListener)desktop.addEventListener('change',reconcile);
  else if(desktop.addListener)desktop.addListener(reconcile);
  document.addEventListener('shopify:section:unload',function(evt){
    if(evt.target&&evt.target.id==='shopify-section-sidebar'){
      var old=portaled();if(old)old.remove();
    }
  });
  document.addEventListener('shopify:section:load',function(){
    requestAnimationFrame(mount);
  });
}());
